/// <amd-module name="VSSUI/Components/IdentityCard/IdentityCardIdentityUtils" />
import { IIdentity } from "../Persona/Persona.Props";

export function isCompleteIdentity(identity: IIdentity | undefined, checkMail?: boolean) {
    if (!identity) {
        return false;
    }
    if (isGroup(identity)) {
        return identity.mail || identity.displayName;
    }
    if (isAadUser(identity) || isAdUser(identity)) {
        return !!(
            (checkMail && identity.mail) ||
            identity.mailNickname ||
            identity.jobTitle ||
            identity.department ||
            identity.physicalDeliveryOfficeName ||
            identity.manager ||
            identity.surname ||
            identity.telephoneNumber
        );
    } else if (isVsdUser(identity)) {
        return !!identity.signInAddress;
    } else if (isWmdUser(identity)) {
        return !!(identity.scopeName || identity.signInAddress);
    }

    return false;
}

export function isAadUser(identity: IIdentity | undefined): boolean {
    return !!identity && !!identity.originDirectory && identity.originDirectory.trim().toLowerCase() === "aad";
}

export function isAadServicePrincipal(identity: IIdentity | undefined): boolean {
    return !!identity && !!identity.subjectDescriptor && identity.subjectDescriptor.trim().startsWith("aadsp");
}

export function isAdUser(identity: IIdentity | undefined): boolean {
    return !!identity && !!identity.originDirectory && identity.originDirectory.trim().toLowerCase() === "ad";
}

export function isGithubUser(identity: IIdentity | undefined): boolean {
    return !!identity && !!identity.originDirectory && identity.originDirectory.trim().toLowerCase() === "github";
}

export function isGroup(identity: IIdentity | undefined): boolean {
    return !!identity && !!identity.entityType && identity.entityType.trim().toLowerCase() === "group";
}

export function isVsdUser(identity: IIdentity | undefined): boolean {
    return !!identity && !!identity.originDirectory && identity.originDirectory.trim().toLowerCase() === "vsd";
}
export function isWmdUser(identity: IIdentity | undefined): boolean {
    return !!identity && !!identity.originDirectory && identity.originDirectory.trim().toLowerCase() === "wmd";
}
